if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    isSizeQuantityForm() {
      return this.hasAttribute('data-size-quantity-form');
    }

    getSizeQuantityItems() {
      const formId = this.form.getAttribute('id');
      if (!formId || !formId.startsWith('product-form-')) return [];

      const sectionId = formId.replace('product-form-', '');
      const container = document.querySelector('.variant-picker__container[data-section="' + sectionId + '"]');

      if (!container) return [];

      const inputs = container.querySelectorAll('.size-quantity-input');

      const items = Array.from(inputs).reduce((acc, input) => {
        const qty = parseInt(input.value, 10);
        if (qty > 0 && input.dataset.variantId) {
          acc.push({ id: parseInt(input.dataset.variantId, 10), quantity: qty });
        }
        return acc;
      }, []);

      return items;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;
      
      // Check if this is a custom order product and validate options
      const customOrderWidget = document.getElementById('customOrderTee');
      if (customOrderWidget) {
        const hasOptions = window.productCustomizer?.hasCustomOrderOptions?.();
        if (!hasOptions) {
          this.handleErrorMessage('Please select at least one option to customize your order.');
          submitButton.focus();
          return;
        }
      }

      if (this.isSizeQuantityForm()) {
        const items = this.getSizeQuantityItems();
        if (items.length === 0) {
          this.handleErrorMessage('Please select at least one size and quantity.');
          return;
        }
        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';
        const sections = this.cartNotification.getSectionsToRender().map((section) => section.id);
        config.body = JSON.stringify({
          items,
          sections: sections.join(','),
          sections_url: window.location.pathname
        });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description || 'Unable to add items to cart.');
              return;
            }
            this.cartNotification.renderContents(response);

            // Reset size-quantity inputs and re-sync with cart
            const currentFormId = this.form.getAttribute('id') || '';
            const sectionId = currentFormId.replace('product-form-', '');
            const container = document.querySelector('.variant-picker__container[data-section="' + sectionId + '"]');
            if (container) {
              container.querySelectorAll('.size-quantity-input').forEach(function(input) {
                input.value = '0';
                var row = input.closest('.variant-picker__item-row');
                if (row) row.classList.remove('variant-picker__item-row--has-quantity');
              });
            }
            if (typeof window.syncSizeQuantityWithCart === 'function') {
              window.syncSizeQuantityWithCart();
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('Something went wrong. Please try again.');
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
        return;
      }

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          this.cartNotification.renderContents(response);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
